// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import caiImg from "../../../public/images/cai.jpg";

const ChangeAccountInfo = () => (
  <Layout>
    <SEOHead title="Change Account Information" />

    <FaqTemplate title="Change Account Information">
      <FaqP>
        Need to make some account changes? No problem! Let us know how you would
        like your account to be reflected in our billing system. All change
        information requests are reviewed by a team member. We will confirm the
        changes with you before they take effect.
      </FaqP>

      <Image
        src={caiImg}
        alt="Change Account Information"
        className="img-fluid"
        placeholder="blur"
      />
    </FaqTemplate>
  </Layout>
);

export default ChangeAccountInfo;
